import PowerBiReport from '../Components/PowerbiDashboard/PowerBiReport';
import ReportDownload from '../Components/PowerbiDashboard/ReportDownload';
import ApplicationSettings from '../Components/Settings/Application';


const aqi_request = {
        "moduleId": "AQI",
        "reportId": "AQIDashboard"
};


export const routes = [
        {
                path: `${process.env.PUBLIC_URL}/aqi-dashboard`, Component: <PowerBiReport request_param={aqi_request} />,
                allowedRoles: ['AQI_ADMIN', 'AQI_ANALYST'], moduleId: 5
        },
        {
                path: `${process.env.PUBLIC_URL}/application-settings`, Component: <ApplicationSettings />, allowedRoles: ['ASO_ADMIN', 'ASO_USER', 'EMISSIONS_ADMIN', 'EMISSIONS_ANALYST', 'EMISSIONS_APPROVER',
                        'DECARB_ADMIN', 'DECARB_ANALYST', 'AQI_ADMIN', 'AQI_ANALYST', 'HVAC_ADMIN', 'HVAC_ANALYST', 'SUSTAINABILITY_ADMIN', 'SUSTAINABILITY_ANALYST', 'EMISSIONS_REPORT_USER', 'SUSTAINABILITY_REPORT_USER'], moduleId: 0
        },
        {
                path: `${process.env.PUBLIC_URL}/downloads`, Component: <ReportDownload />, allowedRoles: ['ASO_ADMIN', 'ASO_USER', 'EMISSIONS_ADMIN', 'EMISSIONS_ANALYST', 'EMISSIONS_APPROVER',
                        'DECARB_ADMIN', 'DECARB_ANALYST', 'AQI_ADMIN', 'AQI_ANALYST', 'HVAC_ADMIN', 'HVAC_ANALYST', 'SUSTAINABILITY_ADMIN', 'SUSTAINABILITY_ANALYST', 'EMISSIONS_REPORT_USER', 'SUSTAINABILITY_REPORT_USER'], moduleId: 0
        },
];


